
import {Component, Vue, Watch} from "vue-property-decorator";
import {API_SHIPPING_ADDRESS_LIST, API_SHIPPING_ADDRESS_EXPORT} from "@/configs/Apis";
import DContainerLayout from "../base/DContainerLayout.vue";
import DList from "@/views/base/DList.vue";
import ModifyShippingAddress from "./subviews/ModifyShippingAddress.vue";
import {Fetcher} from "@/utils/Request";
import {isEmpty, isEmptyOrWhiteSpace, showConfirm, showError, showSuccess, showWarning} from "@/utils/Common";
import {MSG_001, MSG_DELETE_SUCCESS, MSG_EXPORT_FILE_NOTFOUND} from "@/configs/Consts";

import {Cascader, Tooltip} from "element-ui";

Vue.use(Cascader);

Vue.use(Tooltip);

@Component({
  components: {
    DList,
    DContainerLayout,
    ModifyShippingAddress
  }
})
export default class ShippingAddress extends Vue {
  queryStr = "";

  queryData: any = {
    contact: ""
  };

  addShippingAddressDialogVisible = false;

  shippingAddressItem: any = {};

  showSearch = false;

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  get dataApi() {
    return API_SHIPPING_ADDRESS_LIST;
  }

  isEditShippingAddress() {
    return this.shippingAddressItem && !isEmpty(this.shippingAddressItem.id);
  }

  createTableColumns() {
    const columns: Array<TableColumnOption> = [
      {
        prop: "asDefault",
        display: "默认",
        width: 80,
        formatter: (data: any, column: any, value: any) => `${value === true ? "是" : ""}`
      },
      {
        prop: "contact",
        display: "姓名",
        width: 160
      },
      {
        prop: "address",
        display: "地址",
        formatter: (data: any, column: any, value: any) => `${data.province} ${data.city} ${data.area} ${value}`
      },
      {
        prop: "phone",
        display: "电话",
        width: 160
      },
      {
        prop: "zipCode",
        display: "邮编",
        width: 160
      },
      {
        prop: "enterprise",
        display: "单位",
        width: 280
      }
    ];
    this.$store.dispatch("shippingaddress/setColumns", columns);
  }

  editShippingAddress() {
    const selectedRows = (this.$refs.shppingaddressgrid as any).getSelectedDataRows();
    if (!selectedRows || !selectedRows.length) {
      showWarning(MSG_001);
      return;
    }
    const row = selectedRows[0];
    const fields = ["id", "contact", "province", "city", "area", "address", "phone", "zipCode", "enterprise", "asDefault"];
    const newItem: { [key: string]: any } = {};

    fields.forEach(name => newItem[name] = row[name]);
    this.shippingAddressItem = newItem;
    this.addShippingAddressDialogVisible = true;
  }

  newShippingAddress() {
    this.addShippingAddressDialogVisible = true;
  }

  onSaveShippingAddressSuccess() {
    this.doSearch();
    this.addShippingAddressDialogVisible = false;
    this.shippingAddressItem = {};
  }

  async deleteShippingAddress() {
    const selectedRows = (this.$refs.shppingaddressgrid as any).getSelectedDataRows();
    if (!selectedRows || !selectedRows.length) {
      showWarning(MSG_001);
      return;
    }
    const row = selectedRows[0];
    try {
      await showConfirm(`此操作将彻底删除: ${row.contact}, 是否继续?`);
      try {
        await this.$store.dispatch("shippingaddress/deleteShippingAddress", row.id);
        this.doSearch();
        showSuccess(MSG_DELETE_SUCCESS);
      } catch (e: any) {
        await showError(e.message);
      }
    } catch (e) {

    }
  }

  onQueryChanged() {
    this.queryStr = JSON.stringify(this.queryData);
  }

  doSearch() {
    this.queryStr += " ";
  }

  exportData(cmd: string) {
    let params: any = {};
    if (cmd === "selected") {
      const selectedRows = (this.$refs.shppingaddressgrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }

      params.selectedIds = selectedRows;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    Fetcher.queryData(API_SHIPPING_ADDRESS_EXPORT, params).then(url => {
      if (isEmpty(url)) {
        showWarning(MSG_EXPORT_FILE_NOTFOUND);
        return;
      }
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      if (a.parentNode) {
        a.parentNode.removeChild(a);
      }
    }).catch(({message}) => showError(message));
  }

  onTextKeyup() {
    ((this.$refs.searchBtn as Vue).$el as HTMLInputElement).focus();
  }
}
